/* eslint-disable jira/filename-case */

import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import {
	classicSoftwareProjectLayout,
	softwareProjectLayout,
} from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { userBoardLayout } from '@jira/platform__layouts-user-board-layout/src/index.tsx';

// TODO Remove this when all route paths are no longer ambiguous
export const genericProjectLayout: Layout = composeLayouts(
	classicSoftwareProjectLayout,
	coreProjectLayout,
	serviceProjectLayout,
	softwareProjectLayout,
	userBoardLayout,
);
